<template>
    <div v-html="displayValue"></div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'

    export default {
        mixins: [formElementMixin]
    }
</script>